import { SITE } from "@/config";
import { Chapter, Reveal } from "@/components/Reveal";
import { PrimaryCTA, GhostCTA } from "@/components/CTA";

const MICRO = ["5 aree analizzate", "8–12 minuti", "Analisi gratuita"];

const FreedomPage = () => (
  <div data-testid="bf360-page" className="bg-ink pt-[72px] text-white">
    <div className="mx-auto max-w-[1440px] px-6 py-20 lg:px-12 lg:py-32">
      <Chapter index="BF360" label="Business Freedom 360" dark />
      <Reveal>
        <h1 className="max-w-4xl font-display text-[clamp(2.4rem,6vw,5rem)] font-extrabold leading-[1.03] tracking-tighter">
          Quanto sei realmente <span className="text-accent">libero</span> dalla tua azienda?
        </h1>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
          BF360 è un sistema di analisi che misura l'Indice di Libertà Imprenditoriale attraverso 5
          aree strategiche della tua realtà imprenditoriale.
        </p>
      </Reveal>

      <Reveal className="mt-20">
        <div
          className="gold-glow-hover border border-accent/25 bg-[#0C0C0C] p-8 lg:p-14"
          data-testid="bf360-overview"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-accent">
            Indice di Libertà Imprenditoriale
          </p>
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-extrabold leading-[1.08] tracking-tighter sm:text-4xl">
            5 aree strategiche della tua realtà imprenditoriale.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/55">
            Il questionario BF360 ti aiuta a capire quanto la tua azienda sia realmente autonoma e
            quanto dipenda ancora dalla tua presenza, restituendoti un quadro chiaro del tuo punto
            di partenza.
          </p>
          <div className="mt-10 flex flex-wrap gap-3" data-testid="bf360-page-microinfo">
            {MICRO.map((m) => (
              <span
                key={m}
                className="border border-accent/30 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-accent"
              >
                {m}
              </span>
            ))}
          </div>
          <div className="mt-12">
            <PrimaryCTA href={SITE.bf360} testid="bf360-page-cta">
              Scopri il tuo indice di libertà
            </PrimaryCTA>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="mt-20 flex flex-wrap gap-4">
        <GhostCTA to="/" dark testid="bf360-page-back">
          Torna alla home
        </GhostCTA>
      </Reveal>
    </div>
  </div>
);

export default FreedomPage;
